

























































import VueOptions from '@utils/VueOptions'

# OPTIONS
# {
#   bar: {
#     theme: 'default',
#     max: 12,
#     icon: {
#       name: null,
#       size: 'sm',
#       style: null,
#       color: null
#     }
#   },
#   tag: {
#     theme: 'default',
#     format: 'formatTitle',
#     showIcon: true,
#     showText: true,
#     maxLength: 12
#   }
# }

tagThemes = {
  default: {
    highlighted: 'bg-white text-recess border border-recess rounded-full',
    unhighlighted: 'bg-white text-recess border border-recess rounded-full'
  },
  card: {
    highlighted: 'bg-white text-orange border border-orange rounded-full'
    unhighlighted: 'bg-recess-glass text-grey-dark border border-grey rounded-full'
  },
  selector: {
    highlighted: 'bg-white text-recess shadow rounded',
    unhighlighted: 'bg-white text-recess shadow rounded'
  },
  danger: {
    highlighted: 'bg-white text-orange border border-orange rounded-full'
    unhighlighted: 'bg-red-lightest text-red border border-red rounded-full'
  },
}

barThemes = {}

settings =
  name: 'TagBar'

  vue:
    props: ['tags', 'highlightedTags', 'primaryTag', 'options', 'actions']

    data: ->
      displayAll: false

    mounted: ->
      @displayAll = true if @options?.initializeExpanded

    computed:
      barOptions: -> @options?.bar || {}
      tagOptions: -> @options?.tag || {}

      showText: ->
        show = true
        show = false if false is @tagOptions.showText
        show

      hideText: -> !@showText

      normalizedTags: -> @tags.map(@normalizeTag)
      normalizedHighlightedTags: -> @tagsToHighlight.map(@normalizeTag)

      normalizedTagIds: -> @normalizedTags.map((tag) -> tag.id)
      normalizedHighlightedTagIds: -> @normalizedHighlightedTags.map((tag) -> tag.id)

      tagsToHighlight: -> @highlightedTags || @tags || []

      sortedTags: -> [...@selectedTags, ...@unselectedTags]
      selectedTags: -> @normalizedTags.filter((tag) => @normalizedHighlightedTagIds.includes(tag.id)).sort(@sortTags)
      unselectedTags: -> @normalizedTags.filter((tag) => !@normalizedHighlightedTagIds.includes(tag.id)).sort(@sortTags)

      maxHighlightedTagListLength: -> 
        if @displayAll then @tags.length else @maxCount

      highlightedTagList: ->
        @sortedTags.filter((tag) => @normalizedHighlightedTagIds.includes(tag.id))[0..(@maxHighlightedTagListLength - 1)]

      unhighlightedTagList: ->
        return [] if @highlightedTagList.length >= @maxHighlightedTagListLength
        list = @sortedTags[@highlightedTagList.length..-1]
        return list if @displayAll
        length = @maxCount - @highlightedTagList.length
        tags = list[0..(length-1)]
        tags

      hiddenTagList: -> @sortedTags[@maxCount..-1]

      maxCount: -> @barOptions.max || 10

      tagStyle: ->
        style = tagThemes[@tagOptions.theme]
        style ||= tagThemes.default
        style

      tagLength: -> @tagOptions.maxLength || 12

      cursorStyle: ->
        cursor = 'cursor-pointer' if @actions?.onClick?
        cursor ||= 'cursor-default'
        cursor

      barIconStyle: ->
        { name, style, size, color } = @barOptions.icon

        color ||= 'text-recess'
        size ||= 'sm'

        style = @faIconClass name, { style }
        style ||= 'fas fa-question'
        style = "#{color} text-#{size} #{style}"
        style

      hiddenTagsTooltip: ->
        @hiddenTagList.map((tag) => @formatTag(tag)).join(', ') if @hiddenTagList.length

      hasRemoveAction: -> @actions?.onRemove?

    methods:
      tagTooltip: (tag) ->
        name = @formatTag(tag)
        t = name if @hideText or name.length > (@tagLength / 0.8) + 1
        t = tag.tooltip if tag.tooltip?
        t

      tagIconClass: (tag) ->
        defaultIcon = { name: tag.id, size: 'sm', color: '' }
        icon  = tag.icon || tag.data.icon || defaultIcon
        faCss = @faIconClass(icon.name)
        return unless faCss?
        "#{faCss} #{icon.size} #{icon.color}"

      normalizeTag: (tag) ->
        idField = 'id' if tag?.id?
        idField ||= 'key' if tag?.key?
        idField ||= @options?.idField || 'id'

        nameField = 'name' if tag?.name?
        nameField ||= 'label' if tag?.label?
        nameField ||= 'value' if tag?.value?
        nameField ||= @options?.nameField || 'name'

        id = tag[idField] if tag[idField]
        id ||= tag
        
        name = tag[nameField] if tag[nameField]
        name ||= tag

        tagObj = { id, name, data: tag}
        tagObj.tooltip = tag.tooltip if tag.tooltip?
        tagObj.iconClass = @tagIconClass tagObj
        tagObj

      formatTag: (tag) ->
        f = @tagOptions.format
        f ||= 'formatTitle'
        @$options.filters[f](tag.name)

      sortTags: (a, b) ->
        return 1 if a.id is @primaryTag || b.id is @primaryTag
        a.name - b.name

      hiTag: (tag) -> @actions?.onClick?(tag.data)

      hiRemoveTag: (tag) -> @actions?.onRemove?(tag.data)

export default VueOptions.vue settings
